type CustomDateRange = { from?: Date; to?: Date };

const formatYmd = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const resolveDateRange = (
  selectedDays: number,
  customDateRange: CustomDateRange,
): { dateFrom: string; dateTo: string } => {
  if (customDateRange.from && customDateRange.to) {
    return {
      dateFrom: formatYmd(customDateRange.from),
      dateTo: formatYmd(customDateRange.to),
    };
  }
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - selectedDays);
  return { dateFrom: formatYmd(from), dateTo: formatYmd(to) };
};
